"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (e) {
    return _typeof2(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
  })(e);
}

function _classCallCheck(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), e;
}

function _slicedToArray(e, r) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, r) || _unsupportedIterableToArray(e, r) || _nonIterableRest();
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArrayLimit(e, r) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var t = [],
        n = !0,
        o = !1,
        a = void 0;

    try {
      for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (t.push(c.value), !r || t.length !== r); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, a = e;
    } finally {
      try {
        n || null == i["return"] || i["return"]();
      } finally {
        if (o) throw a;
      }
    }

    return t;
  }
}

function _unsupportedIterableToArray(e, r) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(e, r) : void 0;
  }
}

function _arrayLikeToArray(e, r) {
  (null == r || r > e.length) && (r = e.length);

  for (var t = 0, n = new Array(r); t < r; t++) {
    n[t] = e[t];
  }

  return n;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(e, r) {
  var t;

  if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
    if (Array.isArray(e) || (t = _unsupportedIterableToArray(e)) || r && e && "number" == typeof e.length) {
      t && (e = t);
      var _n = 0;
      return {
        s: r = function r() {},
        n: function n() {
          return _n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[_n++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: r
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      c = !1;
  return {
    s: function s() {
      t = e[Symbol.iterator]();
    },
    n: function n() {
      var e = t.next();
      return a = e.done, e;
    },
    e: function e(_e2) {
      c = !0, o = _e2;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (c) throw o;
      }
    }
  };
}

function createCommonjsModule(e, r, t) {
  return e(t = {
    path: r,
    exports: {},
    require: function require(e, r) {
      return commonjsRequire(e, null == r ? t.path : r);
    }
  }, t.exports), t.exports;
}

function commonjsRequire() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}

var SEMVER_SPEC_VERSION = "2.0.0",
    MAX_LENGTH = 256,
    MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991,
    MAX_SAFE_COMPONENT_LENGTH = 16,
    constants = {
  SEMVER_SPEC_VERSION: SEMVER_SPEC_VERSION,
  MAX_LENGTH: MAX_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER,
  MAX_SAFE_COMPONENT_LENGTH: MAX_SAFE_COMPONENT_LENGTH
},
    debug = "object" === ("undefined" == typeof process ? "undefined" : _typeof(process)) && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? function () {
  for (var e, r = arguments.length, t = new Array(r), n = 0; n < r; n++) {
    t[n] = arguments[n];
  }

  return (e = console).error.apply(e, ["SEMVER"].concat(t));
} : function () {},
    debug_1 = debug,
    re_1 = createCommonjsModule(function (e, r) {
  var t = constants.MAX_SAFE_COMPONENT_LENGTH,
      o = (r = e.exports = {}).re = [],
      a = r.src = [],
      c = r.t = {},
      i = 0;
  (e = function e(_e3, r, t) {
    var n = i++;
    debug_1(n, r), c[_e3] = n, a[n] = r, o[n] = new RegExp(r, t ? "g" : void 0);
  })("NUMERICIDENTIFIER", "0|[1-9]\\d*"), e("NUMERICIDENTIFIERLOOSE", "[0-9]+"), e("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), e("MAINVERSION", "(".concat(a[c.NUMERICIDENTIFIER], ")\\.") + "(".concat(a[c.NUMERICIDENTIFIER], ")\\.") + "(".concat(a[c.NUMERICIDENTIFIER], ")")), e("MAINVERSIONLOOSE", "(".concat(a[c.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(a[c.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(a[c.NUMERICIDENTIFIERLOOSE], ")")), e("PRERELEASEIDENTIFIER", "(?:".concat(a[c.NUMERICIDENTIFIER], "|").concat(a[c.NONNUMERICIDENTIFIER], ")")), e("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(a[c.NUMERICIDENTIFIERLOOSE], "|").concat(a[c.NONNUMERICIDENTIFIER], ")")), e("PRERELEASE", "(?:-(".concat(a[c.PRERELEASEIDENTIFIER], "(?:\\.").concat(a[c.PRERELEASEIDENTIFIER], ")*))")), e("PRERELEASELOOSE", "(?:-?(".concat(a[c.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(a[c.PRERELEASEIDENTIFIERLOOSE], ")*))")), e("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), e("BUILD", "(?:\\+(".concat(a[c.BUILDIDENTIFIER], "(?:\\.").concat(a[c.BUILDIDENTIFIER], ")*))")), e("FULLPLAIN", "v?".concat(a[c.MAINVERSION]).concat(a[c.PRERELEASE], "?").concat(a[c.BUILD], "?")), e("FULL", "^".concat(a[c.FULLPLAIN], "$")), e("LOOSEPLAIN", "[v=\\s]*".concat(a[c.MAINVERSIONLOOSE]).concat(a[c.PRERELEASELOOSE], "?").concat(a[c.BUILD], "?")), e("LOOSE", "^".concat(a[c.LOOSEPLAIN], "$")), e("GTLT", "((?:<|>)?=?)"), e("XRANGEIDENTIFIERLOOSE", "".concat(a[c.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), e("XRANGEIDENTIFIER", "".concat(a[c.NUMERICIDENTIFIER], "|x|X|\\*")), e("XRANGEPLAIN", "[v=\\s]*(".concat(a[c.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(a[c.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(a[c.XRANGEIDENTIFIER], ")") + "(?:".concat(a[c.PRERELEASE], ")?").concat(a[c.BUILD], "?") + ")?)?"), e("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(a[c.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(a[c.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(a[c.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(a[c.PRERELEASELOOSE], ")?").concat(a[c.BUILD], "?") + ")?)?"), e("XRANGE", "^".concat(a[c.GTLT], "\\s*").concat(a[c.XRANGEPLAIN], "$")), e("XRANGELOOSE", "^".concat(a[c.GTLT], "\\s*").concat(a[c.XRANGEPLAINLOOSE], "$")), e("COERCE", "".concat("(^|[^\\d])(\\d{1,").concat(t, "})") + "(?:\\.(\\d{1,".concat(t, "}))?") + "(?:\\.(\\d{1,".concat(t, "}))?") + "(?:$|[^\\d])"), e("COERCERTL", a[c.COERCE], !0), e("LONETILDE", "(?:~>?)"), e("TILDETRIM", "(\\s*)".concat(a[c.LONETILDE], "\\s+"), !0), r.tildeTrimReplace = "$1~", e("TILDE", "^".concat(a[c.LONETILDE]).concat(a[c.XRANGEPLAIN], "$")), e("TILDELOOSE", "^".concat(a[c.LONETILDE]).concat(a[c.XRANGEPLAINLOOSE], "$")), e("LONECARET", "(?:\\^)"), e("CARETTRIM", "(\\s*)".concat(a[c.LONECARET], "\\s+"), !0), r.caretTrimReplace = "$1^", e("CARET", "^".concat(a[c.LONECARET]).concat(a[c.XRANGEPLAIN], "$")), e("CARETLOOSE", "^".concat(a[c.LONECARET]).concat(a[c.XRANGEPLAINLOOSE], "$")), e("COMPARATORLOOSE", "^".concat(a[c.GTLT], "\\s*(").concat(a[c.LOOSEPLAIN], ")$|^$")), e("COMPARATOR", "^".concat(a[c.GTLT], "\\s*(").concat(a[c.FULLPLAIN], ")$|^$")), e("COMPARATORTRIM", "(\\s*)".concat(a[c.GTLT], "\\s*(").concat(a[c.LOOSEPLAIN], "|").concat(a[c.XRANGEPLAIN], ")"), !0), r.comparatorTrimReplace = "$1$2$3", e("HYPHENRANGE", "^\\s*(".concat(a[c.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(a[c.XRANGEPLAIN], ")") + "\\s*$"), e("HYPHENRANGELOOSE", "^\\s*(".concat(a[c.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(a[c.XRANGEPLAINLOOSE], ")") + "\\s*$"), e("STAR", "(<|>)?=?\\s*\\*"), e("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), e("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
}),
    numeric = /^[0-9]+$/,
    compareIdentifiers = function compareIdentifiers(e, r) {
  var t = numeric.test(e),
      n = numeric.test(r);
  return t && n && (e = +e, r = +r), e === r ? 0 : t && !n || (!n || t) && e < r ? -1 : 1;
},
    rcompareIdentifiers = function rcompareIdentifiers(e, r) {
  return compareIdentifiers(r, e);
},
    identifiers = {
  compareIdentifiers: compareIdentifiers,
  rcompareIdentifiers: rcompareIdentifiers
},
    MAX_LENGTH$1 = constants.MAX_LENGTH,
    MAX_SAFE_INTEGER$1 = constants.MAX_SAFE_INTEGER,
    re = re_1.re,
    t = re_1.t,
    compareIdentifiers$1 = identifiers.compareIdentifiers,
    SemVer = function () {
  function o(e, r) {
    if (_classCallCheck(this, o), r && "object" === _typeof(r) || (r = {
      loose: !!r,
      includePrerelease: !1
    }), e instanceof o) {
      if (e.loose === !!r.loose && e.includePrerelease === !!r.includePrerelease) return e;
      e = e.version;
    } else if ("string" != typeof e) throw new TypeError("Invalid Version: ".concat(e));

    if (e.length > MAX_LENGTH$1) throw new TypeError("version is longer than ".concat(MAX_LENGTH$1, " characters"));
    if (debug_1("SemVer", e, r), this.options = r, this.loose = !!r.loose, this.includePrerelease = !!r.includePrerelease, !(r = e.trim().match(r.loose ? re[t.LOOSE] : re[t.FULL]))) throw new TypeError("Invalid Version: ".concat(e));
    if (this.raw = e, this.major = +r[1], this.minor = +r[2], this.patch = +r[3], this.major > MAX_SAFE_INTEGER$1 || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER$1 || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER$1 || this.patch < 0) throw new TypeError("Invalid patch version");
    r[4] ? this.prerelease = r[4].split(".").map(function (e) {
      if (/^[0-9]+$/.test(e)) {
        var r = +e;
        if (0 <= r && r < MAX_SAFE_INTEGER$1) return r;
      }

      return e;
    }) : this.prerelease = [], this.build = r[5] ? r[5].split(".") : [], this.format();
  }

  return _createClass(o, [{
    key: "format",
    value: function value() {
      return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
    }
  }, {
    key: "toString",
    value: function value() {
      return this.version;
    }
  }, {
    key: "compare",
    value: function value(e) {
      if (debug_1("SemVer.compare", this.version, this.options, e), !(e instanceof o)) {
        if ("string" == typeof e && e === this.version) return 0;
        e = new o(e, this.options);
      }

      return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
    }
  }, {
    key: "compareMain",
    value: function value(e) {
      return e instanceof o || (e = new o(e, this.options)), compareIdentifiers$1(this.major, e.major) || compareIdentifiers$1(this.minor, e.minor) || compareIdentifiers$1(this.patch, e.patch);
    }
  }, {
    key: "comparePre",
    value: function value(e) {
      if (e instanceof o || (e = new o(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
      if (!this.prerelease.length && e.prerelease.length) return 1;
      if (!this.prerelease.length && !e.prerelease.length) return 0;
      var r = 0;

      do {
        var t = this.prerelease[r],
            n = e.prerelease[r];
        if (debug_1("prerelease compare", r, t, n), void 0 === t && void 0 === n) return 0;
        if (void 0 === n) return 1;
        if (void 0 === t) return -1;
        if (t !== n) return compareIdentifiers$1(t, n);
      } while (++r);
    }
  }, {
    key: "compareBuild",
    value: function value(e) {
      e instanceof o || (e = new o(e, this.options));
      var r = 0;

      do {
        var t = this.build[r],
            n = e.build[r];
        if (debug_1("prerelease compare", r, t, n), void 0 === t && void 0 === n) return 0;
        if (void 0 === n) return 1;
        if (void 0 === t) return -1;
        if (t !== n) return compareIdentifiers$1(t, n);
      } while (++r);
    }
  }, {
    key: "inc",
    value: function value(e, r) {
      switch (e) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", r);
          break;

        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", r);
          break;

        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", r), this.inc("pre", r);
          break;

        case "prerelease":
          0 === this.prerelease.length && this.inc("patch", r), this.inc("pre", r);
          break;

        case "major":
          0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;

        case "minor":
          0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
          break;

        case "patch":
          0 === this.prerelease.length && this.patch++, this.prerelease = [];
          break;

        case "pre":
          if (0 === this.prerelease.length) this.prerelease = [0];else {
            for (var t = this.prerelease.length; 0 <= --t;) {
              "number" == typeof this.prerelease[t] && (this.prerelease[t]++, t = -2);
            }

            -1 === t && this.prerelease.push(0);
          }
          r && (this.prerelease[0] !== r || isNaN(this.prerelease[1])) && (this.prerelease = [r, 0]);
          break;

        default:
          throw new Error("invalid increment argument: ".concat(e));
      }

      return this.format(), this.raw = this.version, this;
    }
  }]), o;
}(),
    semver = SemVer,
    MAX_LENGTH$2 = constants.MAX_LENGTH,
    re$1 = re_1.re,
    t$1 = re_1.t,
    parse = function parse(e, r) {
  if (r && "object" === _typeof(r) || (r = {
    loose: !!r,
    includePrerelease: !1
  }), e instanceof semver) return e;
  if ("string" != typeof e) return null;
  if (e.length > MAX_LENGTH$2) return null;
  if (!(r.loose ? re$1[t$1.LOOSE] : re$1[t$1.FULL]).test(e)) return null;

  try {
    return new semver(e, r);
  } catch (e) {
    return null;
  }
},
    parse_1 = parse,
    valid = function valid(e, r) {
  return (r = parse_1(e, r)) ? r.version : null;
},
    valid_1 = valid,
    clean = function clean(e, r) {
  return (r = parse_1(e.trim().replace(/^[=v]+/, ""), r)) ? r.version : null;
},
    clean_1 = clean,
    inc = function inc(e, r, t, n) {
  "string" == typeof t && (n = t, t = void 0);

  try {
    return new semver(e, t).inc(r, n).version;
  } catch (e) {
    return null;
  }
},
    inc_1 = inc,
    compare = function compare(e, r, t) {
  return new semver(e, t).compare(new semver(r, t));
},
    compare_1 = compare,
    eq = function eq(e, r, t) {
  return 0 === compare_1(e, r, t);
},
    eq_1 = eq,
    diff = function diff(e, r) {
  if (eq_1(e, r)) return null;
  var t,
      n = parse_1(e),
      o = parse_1(r),
      a = (r = n.prerelease.length || o.prerelease.length) ? "pre" : "",
      r = r ? "prerelease" : "";

  for (t in n) {
    if (("major" === t || "minor" === t || "patch" === t) && n[t] !== o[t]) return a + t;
  }

  return r;
},
    diff_1 = diff,
    major = function major(e, r) {
  return new semver(e, r).major;
},
    major_1 = major,
    minor = function minor(e, r) {
  return new semver(e, r).minor;
},
    minor_1 = minor,
    patch = function patch(e, r) {
  return new semver(e, r).patch;
},
    patch_1 = patch,
    prerelease = function prerelease(e, r) {
  return (r = parse_1(e, r)) && r.prerelease.length ? r.prerelease : null;
},
    prerelease_1 = prerelease,
    rcompare = function rcompare(e, r, t) {
  return compare_1(r, e, t);
},
    rcompare_1 = rcompare,
    compareLoose = function compareLoose(e, r) {
  return compare_1(e, r, !0);
},
    compareLoose_1 = compareLoose,
    compareBuild = function compareBuild(e, r, t) {
  return e = new semver(e, t), t = new semver(r, t), e.compare(t) || e.compareBuild(t);
},
    compareBuild_1 = compareBuild,
    sort = function sort(e, t) {
  return e.sort(function (e, r) {
    return compareBuild_1(e, r, t);
  });
},
    sort_1 = sort,
    rsort = function rsort(e, t) {
  return e.sort(function (e, r) {
    return compareBuild_1(r, e, t);
  });
},
    rsort_1 = rsort,
    gt = function gt(e, r, t) {
  return 0 < compare_1(e, r, t);
},
    gt_1 = gt,
    lt = function lt(e, r, t) {
  return compare_1(e, r, t) < 0;
},
    lt_1 = lt,
    neq = function neq(e, r, t) {
  return 0 !== compare_1(e, r, t);
},
    neq_1 = neq,
    gte = function gte(e, r, t) {
  return 0 <= compare_1(e, r, t);
},
    gte_1 = gte,
    lte = function lte(e, r, t) {
  return compare_1(e, r, t) <= 0;
},
    lte_1 = lte,
    cmp = function cmp(e, r, t, n) {
  switch (r) {
    case "===":
      return "object" === _typeof(e) && (e = e.version), "object" === _typeof(t) && (t = t.version), e === t;

    case "!==":
      return "object" === _typeof(e) && (e = e.version), "object" === _typeof(t) && (t = t.version), e !== t;

    case "":
    case "=":
    case "==":
      return eq_1(e, t, n);

    case "!=":
      return neq_1(e, t, n);

    case ">":
      return gt_1(e, t, n);

    case ">=":
      return gte_1(e, t, n);

    case "<":
      return lt_1(e, t, n);

    case "<=":
      return lte_1(e, t, n);

    default:
      throw new TypeError("Invalid operator: ".concat(r));
  }
},
    cmp_1 = cmp,
    re$2 = re_1.re,
    t$2 = re_1.t,
    coerce = function coerce(e, r) {
  if (e instanceof semver) return e;
  if ("number" == typeof e && (e = String(e)), "string" != typeof e) return null;
  var t,
      n = null;

  if ((r = r || {}).rtl) {
    for (; (t = re$2[t$2.COERCERTL].exec(e)) && (!n || n.index + n[0].length !== e.length);) {
      n && t.index + t[0].length === n.index + n[0].length || (n = t), re$2[t$2.COERCERTL].lastIndex = t.index + t[1].length + t[2].length;
    }

    re$2[t$2.COERCERTL].lastIndex = -1;
  } else n = e.match(re$2[t$2.COERCE]);

  return null === n ? null : parse_1("".concat(n[2], ".").concat(n[3] || "0", ".").concat(n[4] || "0"), r);
},
    coerce_1 = coerce,
    Range = function () {
  function n(e, r) {
    var t = this;
    if (_classCallCheck(this, n), r && "object" === _typeof(r) || (r = {
      loose: !!r,
      includePrerelease: !1
    }), e instanceof n) return e.loose === !!r.loose && e.includePrerelease === !!r.includePrerelease ? e : new n(e.raw, r);
    if (e instanceof comparator) return this.raw = e.value, this.set = [[e]], this.format(), this;
    if (this.options = r, this.loose = !!r.loose, this.includePrerelease = !!r.includePrerelease, this.raw = e, this.set = e.split(/\s*\|\|\s*/).map(function (e) {
      return t.parseRange(e.trim());
    }).filter(function (e) {
      return e.length;
    }), !this.set.length) throw new TypeError("Invalid SemVer Range: ".concat(e));
    this.format();
  }

  return _createClass(n, [{
    key: "format",
    value: function value() {
      return this.range = this.set.map(function (e) {
        return e.join(" ").trim();
      }).join("||").trim(), this.range;
    }
  }, {
    key: "toString",
    value: function value() {
      return this.range;
    }
  }, {
    key: "parseRange",
    value: function value(e) {
      var r = this,
          t = this.options.loose;
      e = e.trim();
      var n = t ? re$3[t$3.HYPHENRANGELOOSE] : re$3[t$3.HYPHENRANGE];
      e = e.replace(n, hyphenReplace(this.options.includePrerelease)), debug_1("hyphen replace", e), e = e.replace(re$3[t$3.COMPARATORTRIM], comparatorTrimReplace), debug_1("comparator trim", e, re$3[t$3.COMPARATORTRIM]), e = (e = (e = e.replace(re$3[t$3.TILDETRIM], tildeTrimReplace)).replace(re$3[t$3.CARETTRIM], caretTrimReplace)).split(/\s+/).join(" ");
      var o = t ? re$3[t$3.COMPARATORLOOSE] : re$3[t$3.COMPARATOR];
      return e.split(" ").map(function (e) {
        return parseComparator(e, r.options);
      }).join(" ").split(/\s+/).map(function (e) {
        return replaceGTE0(e, r.options);
      }).filter(this.options.loose ? function (e) {
        return !!e.match(o);
      } : function () {
        return !0;
      }).map(function (e) {
        return new comparator(e, r.options);
      });
    }
  }, {
    key: "intersects",
    value: function value(e, t) {
      if (!(e instanceof n)) throw new TypeError("a Range is required");
      return this.set.some(function (r) {
        return isSatisfiable(r, t) && e.set.some(function (e) {
          return isSatisfiable(e, t) && r.every(function (r) {
            return e.every(function (e) {
              return r.intersects(e, t);
            });
          });
        });
      });
    }
  }, {
    key: "test",
    value: function value(e) {
      if (!e) return !1;
      if ("string" == typeof e) try {
        e = new semver(e, this.options);
      } catch (e) {
        return !1;
      }

      for (var r = 0; r < this.set.length; r++) {
        if (testSet(this.set[r], e, this.options)) return !0;
      }

      return !1;
    }
  }]), n;
}(),
    range = Range,
    re$3 = re_1.re,
    t$3 = re_1.t,
    comparatorTrimReplace = re_1.comparatorTrimReplace,
    tildeTrimReplace = re_1.tildeTrimReplace,
    caretTrimReplace = re_1.caretTrimReplace,
    isSatisfiable = function isSatisfiable(e, r) {
  for (var t = !0, n = e.slice(), o = n.pop(); t && n.length;) {
    t = n.every(function (e) {
      return o.intersects(e, r);
    }), o = n.pop();
  }

  return t;
},
    parseComparator = function parseComparator(e, r) {
  return debug_1("comp", e, r), e = replaceCarets(e, r), debug_1("caret", e), e = replaceTildes(e, r), debug_1("tildes", e), e = replaceXRanges(e, r), debug_1("xrange", e), e = replaceStars(e, r), debug_1("stars", e), e;
},
    isX = function isX(e) {
  return !e || "x" === e.toLowerCase() || "*" === e;
},
    replaceTildes = function replaceTildes(e, r) {
  return e.trim().split(/\s+/).map(function (e) {
    return replaceTilde(e, r);
  }).join(" ");
},
    replaceTilde = function replaceTilde(a, e) {
  return e = e.loose ? re$3[t$3.TILDELOOSE] : re$3[t$3.TILDE], a.replace(e, function (e, r, t, n, o) {
    return debug_1("tilde", a, e, r, t, n, o), t = isX(r) ? "" : isX(t) ? ">=".concat(r, ".0.0 <").concat(+r + 1, ".0.0-0") : isX(n) ? ">=".concat(r, ".").concat(t, ".0 <").concat(r, ".").concat(+t + 1, ".0-0") : o ? (debug_1("replaceTilde pr", o), ">=".concat(r, ".").concat(t, ".").concat(n, "-").concat(o, " <").concat(r, ".").concat(+t + 1, ".0-0")) : ">=".concat(r, ".").concat(t, ".").concat(n, " <").concat(r, ".").concat(+t + 1, ".0-0"), debug_1("tilde return", t), t;
  });
},
    replaceCarets = function replaceCarets(e, r) {
  return e.trim().split(/\s+/).map(function (e) {
    return replaceCaret(e, r);
  }).join(" ");
},
    replaceCaret = function replaceCaret(a, e) {
  debug_1("caret", a, e);
  var r = e.loose ? re$3[t$3.CARETLOOSE] : re$3[t$3.CARET],
      c = e.includePrerelease ? "-0" : "";
  return a.replace(r, function (e, r, t, n, o) {
    return debug_1("caret", a, e, r, t, n, o), r = isX(r) ? "" : isX(t) ? ">=".concat(r, ".0.0").concat(c, " <").concat(+r + 1, ".0.0-0") : isX(n) ? "0" === r ? ">=".concat(r, ".").concat(t, ".0").concat(c, " <").concat(r, ".").concat(+t + 1, ".0-0") : ">=".concat(r, ".").concat(t, ".0").concat(c, " <").concat(+r + 1, ".0.0-0") : o ? (debug_1("replaceCaret pr", o), "0" === r ? "0" === t ? ">=".concat(r, ".").concat(t, ".").concat(n, "-").concat(o, " <").concat(r, ".").concat(t, ".").concat(+n + 1, "-0") : ">=".concat(r, ".").concat(t, ".").concat(n, "-").concat(o, " <").concat(r, ".").concat(+t + 1, ".0-0") : ">=".concat(r, ".").concat(t, ".").concat(n, "-").concat(o, " <").concat(+r + 1, ".0.0-0")) : (debug_1("no pr"), "0" === r ? "0" === t ? ">=".concat(r, ".").concat(t, ".").concat(n).concat(c, " <").concat(r, ".").concat(t, ".").concat(+n + 1, "-0") : ">=".concat(r, ".").concat(t, ".").concat(n).concat(c, " <").concat(r, ".").concat(+t + 1, ".0-0") : ">=".concat(r, ".").concat(t, ".").concat(n, " <").concat(+r + 1, ".0.0-0")), debug_1("caret return", r), r;
  });
},
    replaceXRanges = function replaceXRanges(e, r) {
  return debug_1("replaceXRanges", e, r), e.split(/\s+/).map(function (e) {
    return replaceXRange(e, r);
  }).join(" ");
},
    replaceXRange = function replaceXRange(u, l) {
  u = u.trim();
  var e = l.loose ? re$3[t$3.XRANGELOOSE] : re$3[t$3.XRANGE];
  return u.replace(e, function (e, r, t, n, o, a) {
    debug_1("xRange", u, e, r, t, n, o, a);
    var c = isX(t),
        i = c || isX(n),
        s = i || isX(o);
    return "=" === r && s && (r = ""), a = l.includePrerelease ? "-0" : "", c ? e = ">" === r || "<" === r ? "<0.0.0-0" : "*" : r && s ? (i && (n = 0), o = 0, ">" === r ? (r = ">=", o = i ? (t = +t + 1, n = 0) : (n = +n + 1, 0)) : "<=" === r && (r = "<", i ? t = +t + 1 : n = +n + 1), "<" === r && (a = "-0"), e = "".concat(r + t, ".").concat(n, ".").concat(o).concat(a)) : i ? e = ">=".concat(t, ".0.0").concat(a, " <").concat(+t + 1, ".0.0-0") : s && (e = ">=".concat(t, ".").concat(n, ".0").concat(a, " <").concat(t, ".").concat(+n + 1, ".0-0")), debug_1("xRange return", e), e;
  });
},
    replaceStars = function replaceStars(e, r) {
  return debug_1("replaceStars", e, r), e.trim().replace(re$3[t$3.STAR], "");
},
    replaceGTE0 = function replaceGTE0(e, r) {
  return debug_1("replaceGTE0", e, r), e.trim().replace(re$3[r.includePrerelease ? t$3.GTE0PRE : t$3.GTE0], "");
},
    hyphenReplace = function hyphenReplace(E) {
  return function (e, r, t, n, o, a, c, i, s, u, l, p, f) {
    return r = isX(t) ? "" : isX(n) ? ">=".concat(t, ".0.0").concat(E ? "-0" : "") : isX(o) ? ">=".concat(t, ".").concat(n, ".0").concat(E ? "-0" : "") : a ? ">=".concat(r) : ">=".concat(r).concat(E ? "-0" : ""), i = isX(s) ? "" : isX(u) ? "<".concat(+s + 1, ".0.0-0") : isX(l) ? "<".concat(s, ".").concat(+u + 1, ".0-0") : p ? "<=".concat(s, ".").concat(u, ".").concat(l, "-").concat(p) : E ? "<".concat(s, ".").concat(u, ".").concat(+l + 1, "-0") : "<=".concat(i), "".concat(r, " ").concat(i).trim();
  };
},
    testSet = function testSet(e, r, t) {
  for (var n = 0; n < e.length; n++) {
    if (!e[n].test(r)) return !1;
  }

  if (!r.prerelease.length || t.includePrerelease) return !0;

  for (var o = 0; o < e.length; o++) {
    if (debug_1(e[o].semver), e[o].semver !== comparator.ANY && 0 < e[o].semver.prerelease.length) {
      var a = e[o].semver;
      if (a.major === r.major && a.minor === r.minor && a.patch === r.patch) return !0;
    }
  }

  return !1;
},
    ANY = Symbol("SemVer ANY"),
    Comparator = function () {
  function i(e, r) {
    if (_classCallCheck(this, i), r && "object" === _typeof(r) || (r = {
      loose: !!r,
      includePrerelease: !1
    }), e instanceof i) {
      if (e.loose === !!r.loose) return e;
      e = e.value;
    }

    debug_1("comparator", e, r), this.options = r, this.loose = !!r.loose, this.parse(e), this.semver === ANY ? this.value = "" : this.value = this.operator + this.semver.version, debug_1("comp", this);
  }

  return _createClass(i, null, [{
    key: "ANY",
    get: function get() {
      return ANY;
    }
  }]), _createClass(i, [{
    key: "parse",
    value: function value(e) {
      var r = this.options.loose ? re$4[t$4.COMPARATORLOOSE] : re$4[t$4.COMPARATOR];
      if (!(r = e.match(r))) throw new TypeError("Invalid comparator: ".concat(e));
      this.operator = void 0 !== r[1] ? r[1] : "", "=" === this.operator && (this.operator = ""), r[2] ? this.semver = new semver(r[2], this.options.loose) : this.semver = ANY;
    }
  }, {
    key: "toString",
    value: function value() {
      return this.value;
    }
  }, {
    key: "test",
    value: function value(e) {
      if (debug_1("Comparator.test", e, this.options.loose), this.semver === ANY || e === ANY) return !0;
      if ("string" == typeof e) try {
        e = new semver(e, this.options);
      } catch (e) {
        return !1;
      }
      return cmp_1(e, this.operator, this.semver, this.options);
    }
  }, {
    key: "intersects",
    value: function value(e, r) {
      if (!(e instanceof i)) throw new TypeError("a Comparator is required");
      if (r && "object" === _typeof(r) || (r = {
        loose: !!r,
        includePrerelease: !1
      }), "" === this.operator) return "" === this.value || new range(e.value, r).test(this.value);
      if ("" === e.operator) return "" === e.value || new range(this.value, r).test(e.semver);
      var t = !(">=" !== this.operator && ">" !== this.operator || ">=" !== e.operator && ">" !== e.operator),
          n = !("<=" !== this.operator && "<" !== this.operator || "<=" !== e.operator && "<" !== e.operator),
          o = this.semver.version === e.semver.version,
          a = !(">=" !== this.operator && "<=" !== this.operator || ">=" !== e.operator && "<=" !== e.operator),
          c = cmp_1(this.semver, "<", e.semver, r) && (">=" === this.operator || ">" === this.operator) && ("<=" === e.operator || "<" === e.operator),
          e = cmp_1(this.semver, ">", e.semver, r) && ("<=" === this.operator || "<" === this.operator) && (">=" === e.operator || ">" === e.operator);
      return t || n || o && a || c || e;
    }
  }]), i;
}(),
    comparator = Comparator,
    re$4 = re_1.re,
    t$4 = re_1.t,
    satisfies = function satisfies(e, r, t) {
  try {
    r = new range(r, t);
  } catch (e) {
    return !1;
  }

  return r.test(e);
},
    satisfies_1 = satisfies,
    toComparators = function toComparators(e, r) {
  return new range(e, r).set.map(function (e) {
    return e.map(function (e) {
      return e.value;
    }).join(" ").trim().split(" ");
  });
},
    toComparators_1 = toComparators,
    maxSatisfying = function maxSatisfying(e, r, t) {
  var n = null,
      o = null,
      a = null;

  try {
    a = new range(r, t);
  } catch (e) {
    return null;
  }

  return e.forEach(function (e) {
    a.test(e) && (n && -1 !== o.compare(e) || (o = new semver(n = e, t)));
  }), n;
},
    maxSatisfying_1 = maxSatisfying,
    minSatisfying = function minSatisfying(e, r, t) {
  var n = null,
      o = null,
      a = null;

  try {
    a = new range(r, t);
  } catch (e) {
    return null;
  }

  return e.forEach(function (e) {
    a.test(e) && (n && 1 !== o.compare(e) || (o = new semver(n = e, t)));
  }), n;
},
    minSatisfying_1 = minSatisfying,
    minVersion = function minVersion(e, r) {
  e = new range(e, r);
  var t = new semver("0.0.0");
  if (e.test(t)) return t;
  if (t = new semver("0.0.0-0"), e.test(t)) return t;
  t = null;

  for (var n = 0; n < e.set.length; ++n) {
    e.set[n].forEach(function (e) {
      var r = new semver(e.semver.version);

      switch (e.operator) {
        case ">":
          0 === r.prerelease.length ? r.patch++ : r.prerelease.push(0), r.raw = r.format();

        case "":
        case ">=":
          t && !gt_1(t, r) || (t = r);
          break;

        case "<":
        case "<=":
          break;

        default:
          throw new Error("Unexpected operation: ".concat(e.operator));
      }
    });
  }

  return t && e.test(t) ? t : null;
},
    minVersion_1 = minVersion,
    validRange = function validRange(e, r) {
  try {
    return new range(e, r).range || "*";
  } catch (e) {
    return null;
  }
},
    valid$1 = validRange,
    ANY$1 = comparator.ANY,
    outside = function outside(n, o, e, a) {
  var c, i, s, u, l;

  switch (n = new semver(n, a), o = new range(o, a), e) {
    case ">":
      c = gt_1, i = lte_1, s = lt_1, u = ">", l = ">=";
      break;

    case "<":
      c = lt_1, i = gte_1, s = gt_1, u = "<", l = "<=";
      break;

    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  if (satisfies_1(n, o, a)) return !1;

  for (var r = 0; r < o.set.length; ++r) {
    var t = function (e) {
      var e = o.set[e],
          r = null,
          t = null;
      return e.forEach(function (e) {
        e.semver === ANY$1 && (e = new comparator(">=0.0.0")), r = r || e, t = t || e, c(e.semver, r.semver, a) ? r = e : s(e.semver, t.semver, a) && (t = e);
      }), r.operator === u || r.operator === l || (!t.operator || t.operator === u) && i(n, t.semver) || t.operator === l && s(n, t.semver) ? {
        v: !1
      } : void 0;
    }(r);

    if ("object" === _typeof(t)) return t.v;
  }

  return !0;
},
    outside_1 = outside,
    gtr = function gtr(e, r, t) {
  return outside_1(e, r, ">", t);
},
    gtr_1 = gtr,
    ltr = function ltr(e, r, t) {
  return outside_1(e, r, "<", t);
},
    ltr_1 = ltr,
    intersects = function intersects(e, r, t) {
  return e = new range(e, t), r = new range(r, t), e.intersects(r);
},
    intersects_1 = intersects,
    simplify = function simplify(e, r, t) {
  var n = [],
      o = null,
      a = null,
      c = e.sort(function (e, r) {
    return compare_1(e, r, t);
  }),
      i = _createForOfIteratorHelper(c);

  try {
    for (i.s(); !(s = i.n()).done;) {
      var s = s.value,
          o = satisfies_1(s, r, t) ? (a = s, o || s) : (a && n.push([o, a]), a = null);
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }

  o && n.push([o, null]);

  for (var u = [], l = 0, p = n; l < p.length; l++) {
    var f = _slicedToArray(p[l], 2),
        E = f[0];

    E === (f = f[1]) ? u.push(E) : f || E !== c[0] ? f ? E === c[0] ? u.push("<=".concat(f)) : u.push("".concat(E, " - ").concat(f)) : u.push(">=".concat(E)) : u.push("*");
  }

  var m = u.join(" || "),
      e = "string" == typeof r.raw ? r.raw : String(r);
  return m.length < e.length ? m : r;
},
    ANY$2 = comparator.ANY,
    subset = function subset(e, r, t) {
  e = new range(e, t), r = new range(r, t);

  var n,
      o = !1,
      a = _createForOfIteratorHelper(e.set);

  try {
    e: for (a.s(); !(n = a.n()).done;) {
      var c = n.value,
          i = _createForOfIteratorHelper(r.set);

      try {
        for (i.s(); !(s = i.n()).done;) {
          var s = s.value,
              s = simpleSubset(c, s, t),
              o = o || null !== s;
          if (s) continue e;
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }

      if (o) return !1;
    }
  } catch (e) {
    a.e(e);
  } finally {
    a.f();
  }

  return !0;
},
    simpleSubset = function simpleSubset(e, r, t) {
  if (1 === e.length && e[0].semver === ANY$2) return 1 === r.length && r[0].semver === ANY$2;

  var n,
      o,
      a,
      c = new Set(),
      i = _createForOfIteratorHelper(e);

  try {
    for (i.s(); !(s = i.n()).done;) {
      var s = s.value;
      ">" === s.operator || ">=" === s.operator ? n = higherGT(n, s, t) : "<" === s.operator || "<=" === s.operator ? o = lowerLT(o, s, t) : c.add(s.semver);
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }

  if (1 < c.size) return null;

  if (n && o) {
    if (0 < (a = compare_1(n.semver, o.semver, t))) return null;
    if (0 === a && (">=" !== n.operator || "<=" !== o.operator)) return null;
  }

  var u,
      l = _createForOfIteratorHelper(c);

  try {
    for (l.s(); !(u = l.n()).done;) {
      var p = u.value;
      if (n && !satisfies_1(p, String(n), t)) return null;
      if (o && !satisfies_1(p, String(o), t)) return null;

      var f = _createForOfIteratorHelper(r);

      try {
        for (f.s(); !(E = f.n()).done;) {
          var E = E.value;
          if (!satisfies_1(p, String(E), t)) return !1;
        }
      } catch (e) {
        f.e(e);
      } finally {
        f.f();
      }

      return !0;
    }
  } catch (e) {
    l.e(e);
  } finally {
    l.f();
  }

  var m = _createForOfIteratorHelper(r);

  try {
    for (m.s(); !(h = m.n()).done;) {
      var h = h.value,
          _ = _ || ">" === h.operator || ">=" === h.operator,
          v = v || "<" === h.operator || "<=" === h.operator;

      if (n) if (">" === h.operator || ">=" === h.operator) {
        if (higherGT(n, h, t) === h) return !1;
      } else if (">=" === n.operator && !satisfies_1(n.semver, String(h), t)) return !1;
      if (o) if ("<" === h.operator || "<=" === h.operator) {
        if (lowerLT(o, h, t) === h) return !1;
      } else if ("<=" === o.operator && !satisfies_1(o.semver, String(h), t)) return !1;
      if (!h.operator && (o || n) && 0 !== a) return !1;
    }
  } catch (e) {
    m.e(e);
  } finally {
    m.f();
  }

  return !(n && v && !o && 0 !== a || o && _ && !n && 0 !== a);
},
    higherGT = function higherGT(e, r, t) {
  return e && (0 < (t = compare_1(e.semver, r.semver, t)) || !(t < 0 || ">" === r.operator && ">=" === e.operator)) ? e : r;
},
    lowerLT = function lowerLT(e, r, t) {
  return e && ((t = compare_1(e.semver, r.semver, t)) < 0 || !(0 < t || "<" === r.operator && "<=" === e.operator)) ? e : r;
},
    subset_1 = subset,
    semver$1 = {
  re: re_1.re,
  src: re_1.src,
  tokens: re_1.t,
  SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
  SemVer: semver,
  compareIdentifiers: identifiers.compareIdentifiers,
  rcompareIdentifiers: identifiers.rcompareIdentifiers,
  parse: parse_1,
  valid: valid_1,
  clean: clean_1,
  inc: inc_1,
  diff: diff_1,
  major: major_1,
  minor: minor_1,
  patch: patch_1,
  prerelease: prerelease_1,
  compare: compare_1,
  rcompare: rcompare_1,
  compareLoose: compareLoose_1,
  compareBuild: compareBuild_1,
  sort: sort_1,
  rsort: rsort_1,
  gt: gt_1,
  lt: lt_1,
  eq: eq_1,
  neq: neq_1,
  gte: gte_1,
  lte: lte_1,
  cmp: cmp_1,
  coerce: coerce_1,
  Comparator: comparator,
  Range: range,
  satisfies: satisfies_1,
  toComparators: toComparators,
  maxSatisfying: maxSatisfying,
  minSatisfying: minSatisfying,
  minVersion: minVersion,
  validRange: validRange,
  outside: outside_1,
  gtr: gtr,
  ltr: ltr,
  intersects: intersects,
  simplifyRange: simplify,
  subset: subset
};

!function () {
  function t(e, r) {
    t.installed || (r ? null != semver$1.valid(e.version) ? (t.installed = !0, semver$1.lt(e.version, "3.0.0") ? Object.defineProperties(e.prototype, {
      axios: {
        get: function get() {
          return r;
        }
      },
      $http: {
        get: function get() {
          return r;
        }
      }
    }) : (e.config.globalProperties.axios = r, e.config.globalProperties.$http = r), e.axios = r, e.$http = r) : console.error("Unkown vue version") : console.error("You have to install axios"));
  }

  "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = t : "function" == typeof define && define.amd ? define([], function () {
    return t;
  }) : window.Vue && window.axios && Vue.use(t, window.axios);
}();